import React, { Component } from "react";
import PropTypes from "prop-types";
import RollTitle from "~/scripts/components/RollTitle";

class RollFooter extends Component {
    static propTypes = {
        friends: PropTypes.array,
        facebook: PropTypes.string,
        instagram: PropTypes.string
    };

    renderFriend = friend => {
        return (
            <div key={friend.id} className="roll-footer__item">
                <a
                    className="roll-footer__link"
                    href={friend.uri}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="roll-footer__image"
                        src={friend.logo}
                        alt={friend.title}
                    />
                </a>
            </div>
        );
    };

    renderSocialLink = (text, link) =>
        !link ? null : (
            <a
                className="roll-footer__social"
                href={link}
                target="_blank"
                rel="noopener noreferrer"
            >
                {text}
            </a>
        );

    render() {
        const { friends, facebook, instagram } = this.props;

        return (
            <div className="roll-footer">
                <div className="roll-footer__top">
                    <div className="roll-footer__title">
                        <RollTitle>Friends of Exit Films</RollTitle>
                    </div>
                    <div className="roll-footer__list">
                        {friends && friends.map(this.renderFriend)}
                    </div>
                </div>

                <div className="roll-footer__bottom">
                    {this.renderSocialLink("Facebook", facebook)}
                    {this.renderSocialLink("Instagram", instagram)}
                </div>
            </div>
        );
    }
}

export default RollFooter;



// WEBPACK FOOTER //
// ./src/scripts/components/RollFooter.js